import type { ElementType } from 'react';

import ManageSearch from '@mui/icons-material/ManageSearch';
import { Link as RouterLink } from 'react-router';

import Crown from '@/assets/icons/Crown';
import Button from '@/components/Buttons/Button';
import { useAppDispatch } from '@/hooks/redux-hooks';
import useUserDetails from '@/hooks/useUserDetails';
import { closeDrawer } from '@/slices/drawerSlice';

import type { SxProps } from '@mui/material';

type ButtonType = 'expired' | 'manage' | 'upgrade';

const BUTTON_CONFIG: Record<ButtonType, { icon: ElementType; label: string }> = {
  expired: { icon: Crown, label: 'Upgrade plan' },
  manage: { icon: ManageSearch, label: 'Manage subscription' },
  upgrade: { icon: Crown, label: 'Upgrade plan' }
};

const UpgradeToPremiumButton = ({ sx, type }: { sx?: SxProps; type: ButtonType }) => {
  const { isUserExpired } = useUserDetails();
  const dispatch = useAppDispatch();

  const effectiveType = isUserExpired ? 'expired' : type;
  const { icon: Icon, label } = BUTTON_CONFIG[effectiveType];

  return (
    <Button
      component={RouterLink}
      sx={{
        minWidth: 250,
        outline: 'none',
        boxShadow: 'none',
        border: 'none',
        fontSize: 14,
        ...sx
      }}
      to='/manage-subscription'
      variant='contained'
      onClick={() => {
        dispatch(closeDrawer());
      }}
    >
      <Icon />
      {label}
    </Button>
  );
};

export default UpgradeToPremiumButton;
